import React, { useState, useEffect } from "react";
import Checkbox from "../../../../../components/Checkbox/Checkbox";
import TextButton from "../../../../../components/Buttons/TextButton/TextButton";
import RoundedButton from "../../../../../components/Buttons/RoundedButton/RoundedButton";
import CloseButton from "../../../../../components/Buttons/CloseButton/closeButton";
import municipalityDb from "../../../../../assets/municipalities.json";
import "./municipalityModal.css";

export default function MunicipalityModal({
  onRequestClose,
  selectedMunicipality,
  setSelectedMunicipality,
}) {
  const [searchText, setSearchText] = useState("");

  const handleMunicipalityChange = (municipality) => {
    const lowerCasedMunicipality = municipality.toLowerCase();
    if (selectedMunicipality.includes(lowerCasedMunicipality)) {
      setSelectedMunicipality(
        selectedMunicipality.filter((item) => item !== lowerCasedMunicipality),
      );
    } else {
      setSelectedMunicipality([
        ...selectedMunicipality,
        lowerCasedMunicipality,
      ]);
    }
  };

  const handleClearButtonClick = () => {
    setSelectedMunicipality([]);
    sessionStorage.removeItem("selectedMunicipality");
  };

  const handleSaveButtonClick = () => {
    sessionStorage.setItem(
      "selectedMunicipality",
      JSON.stringify(selectedMunicipality),
    );
    onRequestClose();
  };

  useEffect(() => {
    // Disable scrolling when modal is open
    document.body.classList.add("modal-open");

    // Remove class when modal is closed
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, []);

  const filteredMunicipalities = municipalityDb.municipalities.filter(
    (municipalityLabel) =>
      municipalityLabel.toLowerCase().includes(searchText.toLowerCase()),
  );

  return (
    <>
      <div className="municipality-modal-container">
        <div className="municipality-modal-top">
          <input
            className="municipality-search"
            type="text"
            value={searchText}
            placeholder="Sök kommun"
            onChange={(event) => setSearchText(event.target.value)}
          />
          <CloseButton onClick={onRequestClose} />
        </div>

        <div className="searchResults-modal-checkboxes">
          {filteredMunicipalities.map((municipalityLabel, index) => (
            <Checkbox
              key={index}
              label={municipalityLabel}
              isChecked={selectedMunicipality.includes(
                municipalityLabel.toLowerCase(),
              )}
              onChange={() => handleMunicipalityChange(municipalityLabel)}
            />
          ))}
        </div>

        <div id="searchResults-modal-buttons">
          <TextButton label="Rensa" onClick={handleClearButtonClick} />
          <RoundedButton
            color="green"
            size="xs"
            label="Spara"
            onClick={handleSaveButtonClick}
          />
        </div>
      </div>
      <div className="municipality-modal-backdrop" onClick={onRequestClose} />
    </>
  );
}
